var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNzNewZealand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V45H60V0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H30V22.5H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzNewZealand);
export default __webpack_public_path__ + "static/media/nz New Zealand.8a3913fbfaade4556f47abe2a543885b.svg";
export { ForwardRef as ReactComponent };